import React from 'react';
import { COMPANY, companyRegistrationLine } from '../../constants/company';

/**
 * Statutory website disclosure: registered name, number and jurisdiction.
 * tone "dark" is for navy footers; "light" is for white page footers.
 */
export default function CompanyDisclosure({ tone = 'dark', showCopyright = true }) {
  const year = new Date().getFullYear();
  const copyrightClass = tone === 'light' ? 'text-sm text-gray-600' : 'text-sm text-gray-400';
  const detailClass = tone === 'light' ? 'text-xs text-gray-500' : 'text-xs text-gray-500';

  return (
    <div className="company-disclosure">
      {showCopyright && (
        <p className={copyrightClass}>
          © {year} {COMPANY.legalName}. All rights reserved.
        </p>
      )}
      <p className={`${detailClass} leading-relaxed ${showCopyright ? 'mt-2' : ''}`}>
        {companyRegistrationLine()}
      </p>
    </div>
  );
}
